// Sets a countdown that counts down to the passed Date value
export const initCountdown = (containerEl: HTMLElement, dateTime: Date) => {
  // If Splide is configured to loop, we need to retrieve
  // multiple elemnts due to slide clones that are created
  const countdownEl = containerEl.getElementsByClassName("countdown__timer") as HTMLCollectionOf<HTMLElement>;

  // If no elements found - do nothing
  if (countdownEl.length <= 0) return;

  // Update each element found
  Array.from(countdownEl).forEach((el) => {
      el.innerHTML = getRemainingTime(dateTime);

      // Update the count down every 1 second
      var currentTimeInterval = setInterval(function() {
        el.innerHTML = getRemainingTime(dateTime);

        // Check if countDownTime is in the past - exit interval
        if (getRemainingTime(dateTime) == "EXPIRED") {
          clearInterval(currentTimeInterval)
          el.parentElement.remove();
        };
      }, 1000);
  })
}

const getRemainingTime = (dateTime: Date) => {
    // Set the date we're counting down to
    var countDownDate = dateTime.getTime();

    // Get today's date and time
    var nowTime= new Date().getTime();

    // Find the distance between now and the countDownDate
    var diff = countDownDate - nowTime;

    // Time calculations for days, hours, minutes and seconds
    var days = Math.floor(diff / (1000 * 60 * 60 * 24));
    var hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((diff % (1000 * 60)) / 1000);

    function padWithZero(number) {
      return (number < 10) ? '0' + number : '' + number;
    }

    let formattedMinutes = padWithZero(minutes);
    let formattedSeconds = padWithZero(seconds);

    // Save the remaining time as string to be output
    var timeRemaining = days + " : " + hours + " : " + formattedMinutes + " : " + formattedSeconds;

    // If the countDownDate is in the past, we return EXPIRED
    if (diff > 0) {
      return timeRemaining;
    } else {
      return "EXPIRED";
    }
}